export const BOOK_CALL_URLS = {
  en: "https://sweep.fillout.com/onboarding-en",
  pl: "https://sweep.fillout.com/onboarding-pl",
};

export const GET_QUOTE_URLS = {
  en: "https://sweep.fillout.com/project-spec-en",
  pl: "https://sweep.fillout.com/project-spec-pl",
};

export const SOCIAL_URLS = {
  instagram: "https://www.instagram.com/sweep.3d.lab/",
  tiktok: "https://www.tiktok.com/@sweep.lab",
};

export const CONTACT_EMAIL = "sweep.3d.lab@gmail.com";
